import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { CustomBoxProps } from 'src/models/DialogBox.interface';

const CustomBox: FC<CustomBoxProps> = ({
  width = '829px',
  height = 'auto',
  border = '1px solid var(--border)',
  borderRadius = '8px',
  padding = '30px',
  marginBottom = 3,
  children,
  title,
  titleFontFamily = 'Lufga',
  titleFontWeight = 500,
  titleFontSize = '24px',
  titleColor = 'var(--primary-navy)',
  titleMarginBottom = 2,
}) => {
  return (
    <Box
      sx={{
        width,
        height,
        border,
        borderRadius,
        padding,
        mb: marginBottom,
        boxShadow: '0px 2px 6px #E2E3E199',
      }}
    >
      {title && (
        <Typography
          fontFamily={titleFontFamily}
          fontWeight={titleFontWeight}
          fontSize={titleFontSize}
          color={titleColor}
          mb={titleMarginBottom}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default CustomBox;
